







































import { Component, Prop, Ref, Mixins, Emit } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";
import TableMixin from "#/mixins/tableMixin";
import PdfLinkMixin from "@/mixins/pdfLinkMixin";
import {
  Headers,
  Item,
  INSTITUTION_NUMBER
} from "@/components/master/doctorpersonnel/list";
import SelectFilter from "#/components/selectFilter/SelectFilter.vue";
import { IsFilterMatch } from "#/components/selectFilter/filter";
import AppSelectTable from "#/components/AppSelectTable.vue";

@Component({
  components: {
    SelectFilter,
    AppSelectTable
  }
})
export default class SelectPersonnel extends Mixins(
  UtilMixin,
  TableMixin,
  PdfLinkMixin
) {
  /** フィルター */
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  /** 医師・関連機関担当者 */
  @Prop({ default: () => [] }) private items!: Item[];
  /** 選択した行 */
  @Prop({ default: () => [] }) private value!: Item[];

  @Emit()
  input(newSelected: Item[]) {
    return newSelected;
  }

  /** 機関種類 */
  private readonly INSTITUTION_NUMBER = INSTITUTION_NUMBER;

  /** 表ヘッダー */
  private headers = Headers;
  /** 表の開いているページ */
  private pageNo = 1;
  /** 表の1ページあたり表示件数 */
  private itemPerPage = 25;
  /** 表内のデータ絞り込みキーワード */
  private keyword = "";

  /** SelectFilterの選択肢 */
  private get ColumnKeys() {
    return this.choiceColumnKey(this.Headers, this.items);
  }

  /** キーワードでクイックフィルタリンクする */
  private get FilterdPersonnels() {
    return this.filterdItems<Item>(this.items, this.keyword);
  }

  /** 絞り込み条件も含めた表ヘッダー */
  private get Headers() {
    return this.headers.map(column => {
      column.filter = val => this.columnFilter(column.value, val);
      return column;
    });
  }

  /** 選択行の一覧を変える */
  private get Value() {
    return this.value;
  }
  private set Value(newSelected: Item[]) {
    this.input(newSelected);
  }

  /** ページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** キーワード変更 */
  private updateKeyword(keyword: string) {
    this.keyword = keyword;
  }

  /** 行を選択できる条件 */
  private isRowSelectable(item: Item) {
    return this.emailFormat(item.mail_address) === true;
  }

  /** カラムフィルター */
  private columnFilter(key: string, val: string | number | Date) {
    if (!this.selectFilter) {
      return true; // フィルターがない場合は、絞り込みをしない
    }
    return IsFilterMatch(this.selectFilter.filterClauses, key, val);
  }
}
